import IColumnState from "../models/IColumnState";

export const initialState: IColumnState = {
    columnLists: {
        columns: undefined,
        error: null,
        loading: false
    },
    addColumn: {
        success: false,
        error: null,
        loading: false
    },
    dataRange:
    {
        data:undefined,
        success: false,
        error: null,
        loading: false

    }
};
